import Footer from "./footer"
import Header from "./header"

function Blogs(){

     return(<>
     <Header/>
      <h1 className="text-center" style={{height:"60vh"}}>this is the blogs components</h1>
      <Footer/>
     </>)
}

export default Blogs